import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import warning from "../images/warning.svg";
import check from "../images/check.svg";
import ReCAPTCHA from "react-google-recaptcha";
import deleteIcon from "../images/close.svg";

export const Form = (props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      product: [],
    },
  });

  const {
    name,
    email,
    contact,
    message,
    cv,
    product,
    messageRequired = true,
  } = props;
  const [loading, setLoading] = useState();
  const [alert, setAlert] = useState();
  const [errAlert, setErrAlert] = useState();

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileUpload = (event) => {
    console.log(event);
    setSelectedFiles([...selectedFiles, ...event.target.files]);
  };

  const handleRemoveFile = (index) => {
    const filesCopy = [...selectedFiles];
    filesCopy.splice(index, 1);
    setSelectedFiles(filesCopy);
  };

  // const headers = {
  //   "Access-Control-Allow-Origin": "*",
  //   "Content-Type": "application/json",
  //   "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
  //   "Access-Control-Allow-Headers":
  //     "Content-Type, Authorization, X-Requested-With, Origin",
  // };

  const onChange = () => {};
  const spinner = <div class="spinner-border text-light" role="status"></div>;

  const success = (
    <div
      class="alert alert-success d-flex align-items-center fade show fadeout"
      role="alert"
      data-bs-dismiss="alert"
      aria-label="Close"
    >
      <img src={check} alt="" />
      <div>Message sent! We will get back to you shortly.</div>
    </div>
  );

  const error = (
    <div
      class="alert alert-warning d-flex align-items-cente fade show fadeout"
      role="alert"
      data-bs-dismiss="alert"
      aria-label="Close"
    >
      <img src={warning} alt="" />
      <div>Oops! Message not delivered. Please try again.</div>
    </div>
  );
  const messageValidation = () => {
    return messageRequired
      ? register("message", { required: "Please enter a message." })
      : register("message");
  };

  const onSubmit = async (data) => {
    console.log("data cv", data.cv);
    setLoading(true);

    console.log("data in form", data);

    const formData = new FormData();

    for (const key in data) {
      if (key === "cv") {
        // data?.cv?.map((file) => {
        //   console.log('file',file)
        //   formData.append(key, file);
        // });
        const numberOfFiles = Object.keys(data?.cv).length;
        for (let i = 0; i < numberOfFiles; i++) {
          formData.append(key, data.cv[i]);
        }
      } else {
        formData.append(key, data[key]);
      }
    }
    console.log(formData);
    await axios
      .post(`${process.env.GATSBY_DEVBACKURL}/contact`, formData)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
          }, 5000);
          reset();
        } else {
          setLoading(false);
          setErrAlert(true);
          setTimeout(() => {
            setErrAlert(false);
          }, 5000);
        }
      })
      .catch((e) => {
        setLoading(false);
        setErrAlert(true);
        setTimeout(() => {
          setErrAlert(false);
        }, 5000);
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} encType="mutipart/form-data">
      <div>{alert && success}</div>
      <div>{errAlert && error}</div>
      {cv && (
        <input
          type="hidden"
          name="cvUpload"
          value="Yes"
          {...register("cvUpload")}
        />
      )}
      {name && (
        <div className="mb-3">
          <input
            type="text"
            placeholder="Name"
            className="form-control"
            {...register("name", { required: "Please enter your name." })}
          />
          {errors.name && <p className="input-error">{errors.name?.message}</p>}
        </div>
      )}

      {email && (
        <div className="mb-3">
          <input
            type="email"
            placeholder="Email"
            className="form-control"
            {...register("email", {
              required: "Please enter your email address.",
            })}
          />
          {errors.email && (
            <p className="input-error">{errors.email?.message}</p>
          )}
        </div>
      )}

      {contact && (
        <div className="mb-3">
          <input
            type="text"
            placeholder="Phone Number"
            className="form-control"
            {...register("contact", {
              // required: "Please enter your contact number.",
              pattern: {
                value: /^\d+$/,
                message: "Please enter a valid number",
              },
            })}
          />
          {errors.contact && (
            <p className="input-error">{errors.contact?.message}</p>
          )}
          {errors.pattern && (
            <p className="input-error">{errors.pattern?.message}</p>
          )}
        </div>
      )}
      {product && (
        <div className="mb-3">
          <div className="py-2">Product</div>
          <div className=" d-flex">
            <div class="form-check form-check-inline d-flex gap-2">
              <input
                class="form-check-input-demo"
                type="checkbox"
                id="inlineCheckbox1"
                value="cre"
                {...register("product", {
                  required: "Please select a product",
                })}
              />
              <label class="form-check-label" for="inlineCheckbox1">
                Contract Rate Explorer
              </label>
            </div>
            <div class="form-check form-check-inline  d-flex gap-2">
              <input
                class="form-check-input-demo"
                type="checkbox"
                id="inlineCheckbox2"
                value="tic"
                {...register("product", {
                  required: "Please select a product",
                })}
              />
              <label class="form-check-label" for="inlineCheckbox2">
                Tara
              </label>
            </div>
            {/* <div class="form-check form-check-inline  d-flex gap-2">
              <input
                class="form-check-input-demo"
                type="checkbox"
                id="inlineCheckbox3"
                value="provider"
                {...register("product", {
                  required: "Please select a product",
                })}
              />
              <label class="form-check-label" for="inlineCheckbox3">
                Provider Search
              </label>
            </div> */}
          </div>

          {errors.product && (
            <p className="input-error">{errors.product?.message}</p>
          )}
        </div>
      )}
      {message && (
        <div className="mb-3">
          <textarea
            className="form-control"
            rows="2"
            placeholder="Leave a message here"
            {...messageValidation()}
          ></textarea>
          {errors?.message && (
            <p className="input-error">{errors.message?.message}</p>
          )}
        </div>
      )}

      {cv && (
        <div className="multi-file-upload my-3">
          {/* <p>
            Upload your CV and additional files if required. Supported file
            types are .pdf and .docx
          </p> */}
          <label for="formFile" class="form-label">
            Upload your CV and additional files if required. Supported file
            types are .pdf and .docx
          </label>
          <input
            className="form-control"
            name="cv"
            type="file"
            id="formFile"
            onChange={handleFileUpload}
            {...register("cv")}
          />
          {/* <input
            type="file"
            multiple="multiple"
            accept=".xlsx,.xls,image/*,.doc, .docx,.pdf,.msword"
            name="cv"
            className="custom-file-input"
            id="file-upload"
            onChange={handleFileUpload}
            {...register("cv")}
          />
          <ul>
            {selectedFiles.map((file, index) => (
              <li key={file.name}>
                {file.name}
                <button type="button" onClick={() => handleRemoveFile(index)}>
                  {file.length > 0 ? `(${file.length})` : ""}
                  <img
                    src={deleteIcon}
                    alt="delete icon"
                    className="close-icon"
                  />
                </button>
              </li>
            ))}
          </ul> */}
          {/* errors.message && <p className="input-error">{errors.cv.message}</p> */}
          {errors?.message && (
            <p className="input-error">{errors?.cv?.message}</p>
          )}
        </div>
      )}

      <ReCAPTCHA
        sitekey="6LfXmwElAAAAAKJ0seYjpP14_qH2CT-IZFIC-tXA"
        onChange={onChange}
        className="py-3"
      />
      <div className="form-submit">
        <button type="submit" className="btn btn-primary float-end">
          Submit
          {loading && spinner}
        </button>
      </div>
    </form>
  );
};
